/**
 * Exports a set of constants matching the reducer composition that container use to define
 * what part of the state shape they operate on
 */
export const STATE = {
  app: 'app',
  startupArea: 'startupArea',
  startupAnonymousArea: 'startupAnonymousArea',
  dashboard: 'dashboard',
  case: 'caseArea',
  responseCaching: 'responseCaching',
  favourite: 'favourite',
  userSettings: 'userSettings',
  userProfile: 'userProfileArea',
  administrationCodetable: 'administrationCodetable',
  userDefaultValues: 'userDefaultValues',
  subscriptions: 'subscriptions',
  administrationSearch: 'administrationSearch',
  administrationEdit: 'administrationEditArea',
  administrationRoleEdit: 'administrationRoleEdit',
  administrationMessages: 'administrationMessages',
  dashboardAdministration: 'dashboardAdministration',
  companyReportAdministration: 'companyReportAdministration',
  favouriteAdministration: 'favouriteAdministration',
  importSetAdministration: 'importSetAdministration',
  externalUrlAdministration: 'externalUrlAdministration',
  externalUrlGroups: 'externalUrlGroups',
  subscriberGroups: 'subscriberGroups',
  experienceTransfer: 'experienceTransfer',
  textConfiguration: 'textConfiguration',
  searchFilters: 'searchFilters',
  companyReport: 'companyReport',
  caseListing: 'caseListing',
  selectionReport: 'selectionReport',
  filters: 'filters',
  bowtie: 'bowtie',
  savedReport: 'savedReport',
  myDownloads: 'myDownloads',
  import: 'import',
  codeSelector: 'codeSelector',
  myNotifications: 'myNotifications',
  remoteData: 'remoteDataArea',
  translatedComponents: 'translatedComponents',
  codetableAccess: 'codetableAccess',
  indicatorFactors: 'indicatorFactors',
  riskMatrix: 'riskMatrixAdministration',
  linkCodes: 'linkCodes',
  linksSection: 'linksSection',
  codeMappings: 'codeMappings',
  importMappings: 'importMappings',
  riskReport: 'riskReport',
  caseTableView: 'caseTableView'
} as const;

export type StatePathType = typeof STATE[keyof typeof STATE];

export const textCollection = {
  [STATE.app]: 1,
  [STATE.startupArea]: 2,
  [STATE.startupAnonymousArea]: 20,
  [STATE.case]: 7,
  [STATE.favourite]: 4,
  [STATE.dashboard]: 6,
  [STATE.userSettings]: 9,
  [STATE.companyReport]: 10,
  [STATE.administrationCodetable]: 26,
  [STATE.administrationSearch]: 11,
  [STATE.administrationEdit]: 12,
  [STATE.administrationRoleEdit]: 12,
  [STATE.administrationMessages]: 28,
  [STATE.dashboardAdministration]: 33,
  [STATE.companyReportAdministration]: 35,
  [STATE.importSetAdministration]: 37,
  [STATE.externalUrlAdministration]: 41,
  [STATE.externalUrlGroups]: 42,
  [STATE.subscriberGroups]: 43,
  [STATE.experienceTransfer]: 44,
  [STATE.textConfiguration]: 31,
  [STATE.searchFilters]: 30,
  [STATE.caseListing]: 4,
  [STATE.selectionReport]: 15,
  [STATE.filters]: 16,
  [STATE.savedReport]: 17,
  [STATE.myDownloads]: 18,
  [STATE.import]: 19,
  [STATE.codeSelector]: 21,
  [STATE.myNotifications]: 22,
  [STATE.bowtie]: 23,
  [STATE.userProfile]: 24,
  [STATE.userDefaultValues]: 25,
  [STATE.subscriptions]: 34,
  [STATE.translatedComponents]: 29,
  [STATE.indicatorFactors]: 26,
  [STATE.riskMatrix]: 26,
  [STATE.linkCodes]: 26,
  [STATE.favouriteAdministration]: 36,
  [STATE.codeMappings]: 38,
  [STATE.importMappings]: 39,
  [STATE.riskReport]: 40,
  [STATE.caseTableView]: 41
};

export const TOKEN_KEY = 'sl:access_token';
export const ID_TOKEN_KEY = 'sl:id_token';

export const debounceExecuteFavouriteWait = 300;
export const appNavbarId = 'app-navbar';
